module.exports = __webpack_public_path__ + "static/media/ic_chevron_danger.d5f6f89e.svg";